import enquire from 'enquire.js';
import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { Responsive } from '../utils';
import { TextColorCheck } from '../utils/textColorCheck';

import './splitted.scss';

const COMPONENT_NAME = 'splitted';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Splitted)
 */
export class Splitted {
  constructor() {
    const self = this;

    this._els = {
      splitted: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.splitted.each(function () {
        const $instanceEl = $(this);
        self.initRelocate($instanceEl);
        self.imageFixedTop($instanceEl);
        self.checkSingleCta($instanceEl);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }

  checkSingleCta($instanceEl) {
    if ($instanceEl.find('.splitted__cta').length > 0 && $instanceEl.find('.tcl-picture__image').length > 0) {
      $instanceEl.addClass('has-cta');
      $instanceEl.find('.tcl-picture__image').click(() => $instanceEl.find('.splitted__cta').first().find('.splitted__link')[0].click());
    }
  }

  imageFixedTop($instanceEl) {
    if ($instanceEl.data('image-fixed-top')) {
      $instanceEl.find('.splitted__media').closest('.frg-row').addClass('image-fixed-top');
    }
  }

  initRelocate($instanceEl) {
    // se c'è almeno un media
    if ($instanceEl.find('.splitted__media')) {
      const isDoubleImage = $instanceEl.find('.splitted__media').length === 2;
      const hasSamePositioning = $instanceEl.find('.splitted__media').first().data('mobile-position') === $instanceEl.find('.splitted__media').last().data('mobile-position');

      // se ci sono due immagini identifico la seconda per far si che anche riposizionata, se nella stessa posizione della prima, venga dopo quest'ultima
      if (isDoubleImage) {
        $instanceEl.find('.splitted__media').last().addClass('seconda-immagine');
      }

      $instanceEl.find('.splitted__media').each(function () {
        const $media = $(this);
        const $mediaContainer = $media.hasClass('splitted__media--small') ? $media.parent() : $media;

        if ($media.hasClass('splitted__media--small')) {
          $media.parent().addClass('frg-col-margin-right');
        }

        // controllo che ci sia il data-mobile-position e che non sia vuoto
        if ($media.data('mobile-position') && $media.data('mobile-position').length > 0) {
          const placeToMove = $media.data('mobile-position');

          // remove margin from content, the margin is set on the image for better positioning, but only in case the positioning is present
          if ($instanceEl.hasClass('splitted--right-media')) {
            $instanceEl.find('.splitted__content').addClass('no-margin-bottom');
          }
          if ($instanceEl.hasClass('splitted--left-media')) {
            $instanceEl.find('.splitted__content').addClass('no-margin-top');
          }

          enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, () => {
            switch (placeToMove) {
              case 'before-title':
                $mediaContainer.relocate('before', $instanceEl.find('.splitted__content').parent());

                // se è un'img verticale o small deve mantenere le proporzioni iniziali quindi sposto anche la colonna in cui si trova
                if ($media.hasClass('splitted__media--small')) {
                  $mediaContainer.relocate('before', $instanceEl.find('.splitted__content').parent());
                }

                // se è la seconda immagine ed è nella stessa posizione della prima la sposto dopo la prima per mantenere l'ordinamento iniziale
                if ($mediaContainer.hasClass('seconda-immagine') && hasSamePositioning) {
                  $mediaContainer.relocate('after', $instanceEl.find('.splitted__media:not(".seconda-immagine")'));
                }
                break;

              case 'after-title':
                if ($instanceEl.find('.splitted__title').length > 0) {
                  $mediaContainer.relocate('after', $instanceEl.find('.splitted__title'));
                } else {
                  // se il titolo non è presente (es. splitted--img-horiz-full-right-rich-text-left.html)
                  $media.addClass('no-title');
                  $mediaContainer.relocate('before', $instanceEl.find('.splitted__content').parent());
                }

                // se è la seconda immagine ed è nella stessa posizione della prima la sposto dopo la prima per mantenere l'ordinamento iniziale
                if ($mediaContainer.hasClass('seconda-immagine') && hasSamePositioning) {
                  $mediaContainer.relocate('after', $instanceEl.find('.splitted__media:not(".seconda-immagine")'));
                }
                break;

              case 'after-text':
                $mediaContainer.relocate('after', $instanceEl.find('.splitted__content'));

                // se è un'img verticale o small deve mantenere le proporzioni iniziali quindi sposto anche la colonna in cui si trova
                if ($media.hasClass('splitted__media--small')) {
                  $mediaContainer.relocate('after', $instanceEl.find('.splitted__content').parent());
                }

                // se è la seconda immagine ed è nella stessa posizione della prima la sposto dopo la prima per mantenere l'ordinamento iniziale
                if ($mediaContainer.hasClass('seconda-immagine') && hasSamePositioning) {
                  $mediaContainer.relocate('after', $instanceEl.find('.splitted__media:not(".seconda-immagine")'));
                }
                break;

              default:
                throw new Error('\ndata-mobile-position error');
            }
          });

          enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, () => {
            $mediaContainer.relocate('origin');
          });
        }
      });
    }
  }
}
